import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../api/client";
import { StatusBadge } from "../../components/shared/StatusBadge";
import { TIMESHEET } from "../../constants/testIds";
import { FileText, Download } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

export default function History() {
    const { user } = useAuth();
    const [rows, setRows] = useState([]);
    const nav = useNavigate();
    useEffect(() => {
        api.get("/v1/timesheets/mine").then((r) => setRows(r.data));
    }, []);
    // provide user_id fallback so the PDF link works for the current user
    const withUser = rows.map((r) => ({ ...r, user_id: r.user_id || user?.id }));
    return (
        <div data-testid={TIMESHEET.historyRoot} className="space-y-6">
            <div>
                <div className="eyebrow">Timesheet</div>
                <h1 className="text-4xl font-extrabold tracking-[-0.03em] leading-none">History</h1>
                <p className="text-muted mt-2 text-sm">Every week you&apos;ve submitted or approved.</p>
            </div>
            <div className="km-card overflow-hidden">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="text-left border-b border-km text-[11px] uppercase tracking-[0.12em] text-muted">
                            <th className="px-4 py-3 font-medium">Week</th>
                            <th className="px-4 py-3 font-medium">Status</th>
                            <th className="px-4 py-3 font-medium text-right">Std hrs</th>
                            <th className="px-4 py-3 font-medium text-right">OT hrs</th>
                            <th className="px-4 py-3 font-medium text-right">KMs</th>
                            <th className="px-4 py-3 font-medium">Signed off by</th>
                            <th className="px-4 py-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {withUser.map((ts) => (
                            <tr key={ts.id} className="border-b border-km hover:bg-[color:var(--surface-2)] cursor-pointer" onClick={() => nav(`/timesheet?week=${ts.week_start}`)}>
                                <td className="px-4 py-3 num">{ts.week_start}</td>
                                <td className="px-4 py-3">
                                    <StatusBadge status={ts.status === "draft" ? "on_hold" : ts.status === "submitted" ? "on_hold" : ts.status === "approved" ? "active" : "legacy"} />
                                </td>
                                <td className="px-4 py-3 num text-right">{(ts.totals?.std_hrs || 0).toFixed(1)}</td>
                                <td className="px-4 py-3 num text-right">{(ts.totals?.ot_hrs || 0).toFixed(1)}</td>
                                <td className="px-4 py-3 num text-right">{(ts.totals?.km || 0).toFixed(0)}</td>
                                <td className="px-4 py-3 text-xs text-muted">{ts.approved_by_name || "—"}</td>
                                <td className="px-4 py-3 text-right">
                                    <a
                                        href={`${process.env.REACT_APP_BACKEND_URL}/api/v1/reports/payroll/${ts.user_id}/${ts.week_start}.pdf`}
                                        target="_blank" rel="noreferrer"
                                        onClick={(e) => e.stopPropagation()}
                                        className="inline-flex items-center gap-1 text-xs text-[color:var(--km-navy)] hover:underline"
                                    >
                                        <FileText size={12} /> PDF
                                    </a>
                                </td>
                            </tr>
                        ))}
                        {!rows.length && (
                            <tr><td colSpan={7} className="py-10 text-center text-muted text-sm">No timesheets yet.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
